"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

require("./toast.css");

var _utils = require("../lib/utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BODY = document.getElementsByTagName("BODY")[0];

var ToastContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ToastContainer, _Component);

  var _super = _createSuper(ToastContainer);

  function ToastContainer(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ToastContainer);
    _this = _super.call(this, props);
    var dataTestId = props.dataTestId;
    _this.el = document.createElement("div");
    _this.el.className = (0, _utils.gatherClasses)(props, "oui-toast-container", "oui-col-xs-12", "oui-col-sm-6", "oui-offset-sm-3", "oui-col-lg-4", "oui-offset-lg-4");

    _this.el.setAttribute("data-testid", dataTestId);

    return _this;
  }

  (0, _createClass2["default"])(ToastContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      BODY.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      BODY.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/_reactDom["default"].createPortal(children, this.el);
    }
  }]);
  return ToastContainer;
}(_react.Component);

ToastContainer.propTypes = {
  dataTestId: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node, _propTypes["default"].func])
};
ToastContainer.displayName = "OrionToastContainer";
var _default = ToastContainer;
exports["default"] = _default;